import { InputLabel, MenuItem, Select } from "@mui/material"
import CountrySelect from "../../../components/CountrySelect"
import useFetch from "../../../api/api"
import { useState, useEffect } from "react"
import Loading from "../../../components/Loading"
import config from "../../../common/Config"

class FieldsHelper {

	getOptionsComponent(pField, pValue, pFunction, pRequiredParameter, pSize) {

		switch (pField){
			case 'market' : {
				const handleChange = (e) => {
					pFunction(e.target.value)
				}

				return (
					<>
						<InputLabel size={pSize || "medium"}>Tipo</InputLabel>
						<Select label="Tipo" value={pValue} onChange={handleChange} size={pSize || "medium"}>
							<MenuItem value="BR">Ações - BR</MenuItem>
							<MenuItem value="US">Stocks - Mundo</MenuItem>
						</Select>
					</>
				)	
			}
			case 'stateOwned' : {
				const handleChange = (e) => {
					pFunction(e.target.value)
				}

				return (
					<>
						<InputLabel size={pSize || "medium"}>Valor</InputLabel>
						<Select label="Valor" value={pValue} onChange={handleChange} size={pSize || "medium"}>
							<MenuItem value="SIM">Sim</MenuItem>
							<MenuItem value="NAO">Não</MenuItem>
						</Select>
					</>
				)
			}
			case 'country' : {
				const handleChange = (e, value) => {
					pFunction(value.map(v => v.code))
				}

				return (
					<CountrySelect width="100%" value={pValue} onChange={handleChange} size={pSize || "medium"} />
				)
			}
			case 'risk' : {
				const handleChange = (e) => {
					pFunction(e.target.value)
				}

				pValue = Array.isArray(pValue) ? pValue : pValue.split(',')

				return (
					<>
						<InputLabel size={pSize || "medium"}>Valor</InputLabel>
						<Select label="Valor" value={pValue} onChange={handleChange} size={pSize || "medium"} multiple>
							<MenuItem value='Baixo'>Baixo</MenuItem>
							<MenuItem value='Médio'>Médio</MenuItem>
							<MenuItem value='Alto'>Alto</MenuItem>
							<MenuItem value='Fora dos Parâmetros'>Fora dos Parâmetros</MenuItem>
						</Select>
					</>				)
			}
			case 'growth' : {
				const handleChange = (e) => {
					pFunction(e.target.value)
				}

				pValue = Array.isArray(pValue) ? pValue : pValue.split(',')

				return (
					<>
						<InputLabel size={pSize || "medium"}>Valor</InputLabel>
						<Select label="Valor" value={pValue} onChange={handleChange} size={pSize || "medium"} multiple>
							<MenuItem value='Baixo'>Lento</MenuItem>
							<MenuItem value='Médio'>Médio</MenuItem>
							<MenuItem value='Rápido'>Rápido</MenuItem>
							<MenuItem value='Fora dos Parâmetros'>Fora dos Parâmetros</MenuItem>
						</Select>
					</>
				)
			}			
			case 'growthRisk' : {
				const handleChange = (e) => {
					pFunction(e.target.value)
				}

				return (
					<>
						<InputLabel size={pSize || "medium"}>Valor</InputLabel>
						<Select label="Valor" value={pValue} onChange={handleChange} size={pSize || "medium"}>
							<MenuItem value='Aprovado'>Aprovado</MenuItem>
							<MenuItem value='Reprovado'>Reprovado</MenuItem>
						</Select>
					</>
				)
			}				
			case 'industry' : {
				return (
					<DynamicDataMenu 
						keyField={'industry'} 
						labelField={'industry'} 
						dataSource={config.apiUrl +'/api/companies/industries?sectors='+ pRequiredParameter} 
						value={pValue} 
						onChange={pFunction} 
						multiple='true'
						size={pSize || "medium"}
					/>)
			}
			case 'sector' : {
				return (
					<DynamicDataMenu 
						keyField='sector' 
						labelField='sector' 
						dataSource={config.apiUrl +'/api/companies/sectors/'+ pRequiredParameter} 
						value={pValue} 
						onChange={pFunction} 
						multiple='true'
						size={pSize || "medium"}
					/>
				)
			}
		}

	}

}

const DynamicDataMenu = (props) => {
	const internalFetch 		= useFetch()
	const [data, setData]		= useState()
	const [options, setOptions]	= useState([])

	useEffect(() => {
		internalFetch(props.dataSource)
		.then(results => results.json())
		.then(results => {
			setData(results)
			loadOptions()
		})
	}, [props.dataSource])

	useEffect(() => {
		loadOptions()
	}, [props.value])

	const loadOptions = () => {
		let selectedValues;
			
		try {
			selectedValues = (props.value ? props.value.split(',') : [])
		}
		catch {
			selectedValues = (props.value ? props.value : [])
		}

		if (data) selectedValues = selectedValues.filter((value) => data.map(r => r[props.keyField]).includes(value));

		setOptions(selectedValues)
	}

	const handleChange = (e) => {
		if (props.onChange) props.onChange(e.target.value)
	}

	if (!data) return <Loading/>

	return (
		<>
			<InputLabel size={props.size || "medium"}>Valor</InputLabel>
			<Select 
				label="Valor" 
				value={options}
				onChange={handleChange} 
				renderValue={(v) => v.length +' itens selecionados'}
				size={props.size || "medium"}
				multiple 
				>
				{data && data.map(d => {
					return (<MenuItem value={d[props.keyField]}>{d[props.labelField]}</MenuItem>)
				})}
			</Select>
		</>
	)
}

export default new FieldsHelper()
